<template>
  <section class="favourites">
    <!-- <transition name="shortfade" mode="out-in"> -->
    <div class="favourites__container" v-if="visibleFlats.length" key="1">
      <pagination
        class="favourites__mobile"
        :flats="sorted"
        v-if="sorted.length > flatsOnPage"
      ></pagination>
      <Button @click.native="toggleFavSidebar" class="favourites__mobile">
        {{ $t('favourites.openSort') }}
      </Button>
      <!-- <transition-group name="flats" class="favourites__grid" tag="div"> -->
      <div class="favourites__grid">
        <card
          v-for="flat in visibleFlats"
          :key="flat[flatProperties['id']]"
          :flat="flat"
        ></card>
      </div>
      <!-- </transition-group> -->
      <pagination
        v-if="sorted.length > flatsOnPage"
        :mb="false"
        :flats="sorted"
      ></pagination>
    </div>
    <div class="favourites__empty" v-else-if="favourites" key="2">
      <p>{{ $t('favourites.noCriteria') }}</p>
    </div>
    <div v-else :key="3" class="favourites__empty">
      <p>{{ $t('favourites.noFavs') }}</p>
    </div>
    <!-- </transition> -->
    <sidebar :flats="sorted" class="favourites__sidebar"></sidebar>
  </section>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import pagination from '@/components/pagination';
import card from '@/components/flat/flat-card';
import Button from '@/components/button';
import sidebar from '@/layout/favourites-sidebar';

export default {
  name: 'favourites',
  components: { pagination, card, sidebar, Button },
  computed: {
    ...mapState({
      flatProperties: state => state.browser.flatProperties,
      flatsOnPage: state => state.browser.flatsOnPage,
      favouritesQuery: state => state.browser.favouritesQuery,
      sorting: state => state.browser.sorting,
    }),
    ...mapGetters({
      favourites: 'GET_FAVOURITES',
      getPlan: 'GET_PLAN',
    }),
    sorted() {
      return this.$store.getters
        .GET_SORTED_AND_FILTERED_FAVOURITES()
        .filter(el => {
          if (this.favouritesQuery == null) {
            return true;
          }
          return (
            el[this.flatProperties['id']]
              .toLowerCase()
              .includes(this.favouritesQuery.toLowerCase()) ||
            this.favouritesQuery
              .toLowerCase()
              .includes(el[this.flatProperties['id']].toLowerCase())
          );
        });
    },
    page() {
      return this.$route.query.page ? this.$route.query.page - 1 : 0;
    },
    visibleFlats() {
      return [...this.sorted].splice(
        this.flatsOnPage * this.page,
        this.flatsOnPage
      );
    },
    filters() {
      return this.$store.state.filters;
    },
  },
  watch: {
    favouritesQuery() {
      this.$router.replace({
        path: this.$route.path,
        params: { ...this.$route.params, page: 0 },
      });
    },
  },
  methods: {
    ...mapMutations({
      toggleFavSidebar: 'TOGGLE_FAV_SIDEBAR',
    }),
    ...mapActions({
      setInvestment: 'SET_INVESTMENT',
    }),
    planURL(flat) {
      if (!flat) return false;
      return this.getPlan(
        flat[this.flatProperties['realID']],
        flat.investmentURL
      );
    },
    status(flat) {
      return this.$store.getters.GET_STATUS_CLASS(
        flat[this.flatProperties['status']]
      );
    },
  },
  mounted() {
    this.setInvestment('baltic-wave');
  },
};
</script>

<style lang="scss">
.favourites {
  display: flex;
  min-height: 100%;
}

.favourites__container {
  max-width: 1000px;
  width: 100%;
  margin: {
    top: 14px;
    left: auto;
    right: auto;
  }

  @media screen and (max-width: $xxl) {
    padding: 0 16px;
    padding-bottom: 0.5rem;
  }
  @media screen and (max-width: $xs) {
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.favourites__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px;
  @media screen and (max-width: $xxl) {
    grid-template-columns: repeat(3, minmax(250px, 1fr));
    grid-gap: 30px;
  }
  @media screen and (max-width: $lg) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  @media screen and (max-width: 400px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

.favourites__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  flex: 1;
  p {
    font-weight: 500;
    font-size: 24px;
    text-align: center;
    padding: 0.7rem;
  }
}

.favourites__mobile {
  @media screen and(min-width: $xs) {
    display: none !important;
  }
}
</style>
